import React, { FC } from 'react';
import { fixed } from 'helicon/build';
import { ValueInputProps } from './ValueInput';
import { IntegerArrayInput } from './IntegerArrayInput';
import { usePosition } from '../../hooks';

export const IntegerArrayFixedValueInput: FC<ValueInputProps<number[]>> = ({
  id,
  disabled,
  seededValue,
  onChange,
  node,
  paramDescription,
}) => {
  const position = usePosition(node.id);
  return (
    <IntegerArrayInput
      id={id}
      disabled={disabled}
      value={seededValue}
      onChange={value => onChange(fixed(value))}
      highlightedIndex={position}
      min={paramDescription.min}
      max={paramDescription.max}
    />
  );
};
